(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-info-collapse"] && !Shopify.designMode) return;
  try {
    (function() {
    function initCollapse(root) {
      if (!root) return;

      var items = root.querySelectorAll('[data-collapse-item]');

      items.forEach(function(item) {
        var button = item.querySelector('.product-info-collapse__button');
        var content = item.querySelector('[data-collapse-content]');
        if (!button || !content) return;

        button.addEventListener('click', function() {
          var isOpen = item.classList.contains('is-open');

          // close all siblings
          items.forEach(function(other) {
            if (other !== item) {
              other.classList.remove('is-open');
              var otherBtn = other.querySelector('.product-info-collapse__button');
              var otherContent = other.querySelector('[data-collapse-content]');
              if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
              if (otherContent) otherContent.style.display = 'none';
            }
          });

          // toggle current
          if (isOpen) {
            item.classList.remove('is-open');
            button.setAttribute('aria-expanded', 'false');
            content.style.display = 'none';
          } else {
            item.classList.add('is-open');
            button.setAttribute('aria-expanded', 'true');
            content.style.display = 'block';
          }
        });
      });

      // Read more / less for description
      var readToggle = root.querySelector('[data-read-toggle]');
      var desc = root.querySelector('[data-collapse-description]');
      if (readToggle && desc) {
        readToggle.addEventListener('click', function() {
          var expanded = desc.classList.toggle('is-expanded');
          if (expanded) {
            desc.style.maxHeight = '2000px';
            readToggle.textContent = readToggle.dataset.readLessText || 'Read less';
          } else {
            desc.style.maxHeight = '{{ desc_max_height }}px';
            readToggle.textContent = readToggle.dataset.readMoreText || 'Read more';
          }
        });
      }
    }

    document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll('[data-product-info-collapse]').forEach(initCollapse);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
